import Header from "../../components/marketing/pageSections/admin/Header";

import TabsContainer from "../../components/marketing/pageSections/admin/components/TabsContainer";
import UsersSubscribed from "../../components/marketing/pageSections/admin/UsersSubscribed";

const BodyAdmin = () => {
  return (
    <>
      <Header />

      <div className="mx-auto flex max-w-7xl flex-col items-center px-6 md:mt-5 md:flex-row md:items-stretch md:justify-start md:space-x-10">
        <TabsContainer />

        <UsersSubscribed />
      </div>
    </>
  );
};

export default BodyAdmin;
